import type { PatternProps } from "./shared";

export function GridPattern({ color, salt }: PatternProps) {
	/** Render */
	return (
		<defs>
			<pattern
				id={`${salt}-gridPattern`}
				patternUnits="userSpaceOnUse"
				width="35"
				height="35"
			>
				<path
					d="M 35 0 L 0 0 0 35"
					fill="none"
					stroke={color}
					strokeWidth="1.75"
				/>
			</pattern>
		</defs>
	);
}
